import { render, staticRenderFns } from "./trawl-table-expanded.vue?vue&type=template&id=7b339131"
import script from "./trawl-table-expanded.vue?vue&type=script&lang=js"
export * from "./trawl-table-expanded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports